import { render, staticRenderFns } from "./change_plan.vue?vue&type=template&id=1ff24694&scoped=true&lang=pug&"
import script from "./change_plan.vue?vue&type=script&lang=js&"
export * from "./change_plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff24694",
  null
  
)

export default component.exports